import React from "react";
import { BRAND } from "../content";
import { openWhatsApp, buildWhatsAppUrl } from "../lib/whatsapp";

const MESSAGE = "Hi DietDotIn, I'd like to book a consultation.";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M20.52 3.48A11.92 11.92 0 0 0 12.02 0C5.46 0 .12 5.34.12 11.9c0 2.1.55 4.14 1.6 5.95L0 24l6.34-1.66a11.86 11.86 0 0 0 5.68 1.45h.01c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.18-3.41-8.41Zm-8.5 18.3h-.01a9.85 9.85 0 0 1-5.02-1.37l-.36-.21-3.76.99 1-3.67-.23-.38a9.86 9.86 0 0 1-1.51-5.24c0-5.46 4.44-9.9 9.9-9.9a9.88 9.88 0 0 1 9.9 9.9c0 5.46-4.44 9.88-9.91 9.88Zm5.43-7.41c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.18.2-.35.22-.65.07-.3-.15-1.27-.47-2.41-1.49-.89-.79-1.49-1.77-1.66-2.07-.18-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01a1.1 1.1 0 0 0-.8.38c-.27.3-1.05 1.03-1.05 2.5 0 1.47 1.08 2.89 1.23 3.09.15.2 2.13 3.25 5.16 4.55.72.31 1.29.5 1.73.64.73.23 1.39.2 1.91.12.58-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.18-1.41-.08-.13-.27-.2-.57-.35Z" />
  </svg>
);

export default function FloatingWhatsApp() {
  const handleClick = (e) => {
    e.preventDefault();
    openWhatsApp({
      phone: BRAND.whatsapp,
      message: MESSAGE,
      displayNumber: BRAND.whatsappDisplay,
    });
  };

  return (
    <a
      href={buildWhatsAppUrl(BRAND.whatsapp, MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 blur-xl group-hover:opacity-70 transition-opacity pulse-glow" />
      <span className="relative flex items-center gap-3 pl-3 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:shadow-[0_14px_40px_rgba(37,211,102,0.55)] transition-shadow">
        <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
          <WhatsAppIcon className="w-5 h-5" />
        </span>
        <span className="hidden sm:inline font-heading font-semibold text-sm">
          Chat on WhatsApp
        </span>
      </span>
    </a>
  );
}
